import { CurrentUser } from "./CurrentUser";
import { Group } from "./Group";
import { Worklist } from "./Worklist";

export enum DistributionType {
  OPEN = "open",
  TARGET = "target",
}

export interface RespondingProvider {
  id: string;
  timeOptIn: string;
  timeOptOut?: string;
  user: { id: string };
}

export interface CodeYellow {
  id: string;
  worklistId: string;
  worklist: Worklist;
  usdPerRvu: number;
  isActive: boolean;
  startTime: Date;
  endTime: Date | null;
  distributionType: DistributionType;
  respondingProviders: RespondingProvider[];
  group?: Group;
  activatingProvider?: CurrentUser;
  limits?: Limits;
  targetedProvidersCount?: number;
  targetedProviders?: string[];
  rvusTotal: number;
  amountTotal: number;
  amountLimit?: number;
  rvusLimit?: number;
  totalAmountPaid: number;
  canManage: boolean;
  userResponded?: boolean;
  studyCount?: number;
}

export interface Limits {
  amountLimit?: number;
  RVUsLimit?: number;
}
